module.exports = __webpack_public_path__ + "static/preview-fab-medium-d419afa95ddfae42c93f08bf2aaa3fca.jpg";